import { Serializable } from '../../common/serializable.interface'
import { ChecklistState } from 'src/app/@store'

export interface ChecklistInstruction {
  id?: number
  caption: string
  order_number?: number
}

export enum ChecklistType {
  CenterDayOpen = 'center_day_open',
  CenterDayClose = 'center_day_close',
  VehiclePreFlight = 'vehicle_preflight',
  VehiclePostFlight = 'vehicle_postflight',
  VehicleDayOpen = 'vehicle_day_open',
  VehicleDayClose = 'vehicle_day_close',
}

interface ChecklistTypeWithLabel {
  label: string
  value: ChecklistType
}

export const ChecklistTypeArray: ChecklistTypeWithLabel[] = [
  { value: ChecklistType.CenterDayOpen, label: 'Center - Day Open' },
  { value: ChecklistType.CenterDayClose, label: 'Center - Day Close' },
  { value: ChecklistType.VehiclePreFlight, label: 'Vehicle - Preflight' },
  { value: ChecklistType.VehiclePostFlight, label: 'Vehicle - Postflight' },
  { value: ChecklistType.VehicleDayOpen, label: 'Vehicle - Day Open' },
  { value: ChecklistType.VehicleDayClose, label: 'Vehicle - Day Close' },
]

export class Checklist extends Serializable<Checklist> implements ChecklistState {
  id: number | null = null
  type: number | string
  name: string | null = null
  owner: string | null = null
  checklist_type: string | null = null
  instructions: ChecklistInstruction[] | null = null
  rules: { every: number; unit: number; id: number }[] | null = null

  constructor(details: Partial<Checklist>) {
    super()
    this.checkAndDeserialize(details)
  }

  deserialize(details: Partial<Checklist>): void {
    this.id = details.id
    this.name = details.name
    this.owner = details.owner
    this.checklist_type = details.checklist_type
    this.instructions = details.instructions || []
  }

  toJSON(): ChecklistState {
    return {
      id: this.id,
      name: this.name,
      owner: this.owner,
      checklist_type: this.checklist_type,
      instructions: this.instructions,
    }
  }
}
